export default __webpack_public_path__ + "static/media/select-role.52a02881.png";